module.exports = __webpack_public_path__ + "static/image/logo-family/logo_ceo@2x.png?85dae0f5";